<template>
    <div ref="nav" class="nav">
        <i ref="icon" @click="toggleNav" class="material-icons">menu</i>
        <div v-show="visible" ref="content" class="nav--content">
            <p ref="about">I grew up in Tokyo, studied in New York. <br>My name is Jia Szeto and I'm a stylist currently based in Paris. <br>Everyday, I try to mix my love for colors, faces and traditions to produce amazing work for TV commercials, photography and exhibitions. <br> Any ideas or projects ? <a href="mailto:contact@jiaszeto.com">contact@jiaszeto.com</a>
            <span class="name" ref="name">Jia</span></p>
        </div>
    </div>
</template>

<script>
import { TimelineMax, Expo } from 'gsap';

export default {
    data() {
        return {
            visible: false
        }
    },
    methods: {
        toggleNav() {
            this.visible ? this.hideNav() : this.showNav();
        },
        showNav() {
            const {content, icon, about, name} = this.$refs;

            icon.style.position = 'fixed';

            const tl = new TimelineMax();
            tl
            .fromTo(content, 1, {top: '-100vh'}, {top: 0, ease: Expo.easeOut})
            .fromTo(about, 1, {top: '55%', opacity: 0}, {top: '50%', opacity: 1,ease: Expo.easeOut}, '-=.3')
            .fromTo(name, 1, {opacity: 0, x: '-10rem'}, {opacity: 1, x: 0, ease: Expo.easeOut}, '-=.5')
            .fromTo(icon, 1, {color: '#ffffff'}, {color: '#161919', ease: Expo.easeOut}, '-=2');
            this.visible = !this.visible;
        },
        hideNav() {
            const {content, icon} = this.$refs;

            icon.style.position = 'absolute';
            window.scrollTo(0, 0);

            const tl = new TimelineMax();
            tl
            .fromTo(content, 1, {top: 0}, {top: '-100vh', ease: Expo.easeOut})
            .fromTo(icon, 1, {color: '#161919'}, {color: '#ffffff', ease: Expo.easeOut, onComplete: () => {
                this.visible = !this.visible;
            }}, '-=1');   
        },
        animateMount() {
            const {icon} = this.$refs;
            const tl = new TimelineMax();
            tl
            .fromTo(icon, 1.5, {opacity: 0, right: '3rem'}, {opacity: 1, right: '5rem',ease: Expo.easeOut});
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Nav.vue